import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import { toast } from "sonner";
import { Check, Syringe } from "@phosphor-icons/react";

export default function Vaccinations() {
  const [schedule, setSchedule] = useState([]);
  const [logs, setLogs] = useState({});
  const [loading, setLoading] = useState(true);

  const load = async () => {
    const [s, l] = await Promise.all([api.get("/vaccinations/schedule"), api.get("/vaccinations/log")]);
    setSchedule(s.data);
    const logMap = {};
    l.data.forEach((x) => { logMap[x.vaccine_id] = x; });
    setLogs(logMap);
    setLoading(false);
  };
  useEffect(() => { load(); }, []);

  const mark = async (id, given_on) => {
    try {
      await api.post("/vaccinations/log", { vaccine_id: id, given_on });
      toast.success(given_on ? "Marked as given." : "Reset.");
      load();
    } catch { toast.error("Could not update."); }
  };

  if (loading) return <div className="text-ink-500">Loading…</div>;

  return (
    <div className="space-y-8" data-testid="vaccinations-page">
      <header>
        <p className="overline text-saffron mb-2">Indian schedule (IAP)</p>
        <h1 className="font-serif font-semibold text-4xl sm:text-5xl">Vaccinations</h1>
        <p className="text-ink-700 mt-2">Tap when given. Vansha keeps watch so you never miss a date.</p>
      </header>

      <div className="space-y-3">
        {schedule.map((v) => {
          const log = logs[v.id];
          const given = !!log?.given_on;
          return (
            <div key={v.id} className={`vansha-card p-6 flex items-start gap-4 ${given ? "opacity-70" : ""}`} data-testid={`vaccine-${v.id}`}>
              <div className={`w-12 h-12 rounded-full flex items-center justify-center flex-shrink-0 ${given ? "bg-saffron/20 text-saffron" : "bg-terracotta/10 text-terracotta"}`}>
                {given ? <Check weight="bold" size={22} /> : <Syringe weight="thin" size={22} />}
              </div>
              <div className="flex-1 min-w-0">
                <p className="overline text-saffron mb-1">{v.schedule}</p>
                <h3 className="font-serif text-xl">{v.name}</h3>
                <p className="text-sm text-ink-700 mt-1">{v.description}</p>
                {given && <p className="text-xs text-saffron mt-2">Given on {new Date(log.given_on).toLocaleDateString()}</p>}
              </div>
              <div className="flex-shrink-0">
                {given ? (
                  <button onClick={() => mark(v.id, null)} className="btn-ghost text-sm" data-testid={`reset-${v.id}`}>Reset</button>
                ) : (
                  <button onClick={() => mark(v.id, new Date().toISOString().slice(0, 10))} className="btn-secondary text-sm" data-testid={`mark-${v.id}`}>Mark given</button>
                )}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
